export const PageFeatureFlags = {
  AccountsAccountBuilderQuizEntryPointEnabled: 'accounts.enable-account-builder-quiz-entry-point',
  CreditBuildingAboveFoldIconsEnabled: 'credit-building-enable-above-fold-icons',
  CoverSMSAppRegEnabled: 'cover.enable-sms-app-reg',
} as const;
